const config = {
  apiUrl: process.env.REACT_APP_SERVICE_API_URL || 'http://mafzmac.local:5010/dev',
  // apiUrl: 'https://api.fajr.io/dev',
  // apiUrl: process.env.REACT_APP_SERVICE_API_URL || " https://ugvoj2ocp7.execute-api.eu-west-1.amazonaws.com/dev"
  googleAnalyticsTrackingId: process.env.REACT_APP_GOOGLE_ANALYTICS || "G-4NVCMFNK1N"

};
export default config;
